
export interface MainSettings {
  theme: ThemeType;
  fontSettings: FontSettings;
  reviewNotificationSettings: ReviewNotificationSettings;
  orderNotebooksBy: OrderBy;
}

export interface FontSettings {
  notesFontSize: NotesFontSize;
}

export enum ThemeType{
  LIGHT = 'Light',
  DARK = 'Dark',
  SYSTEM = 'System'
};

export interface ReviewNotificationSettings {
  email: string,
  enableEmailNotification: boolean,
  notificationPreferedHour: number,
}

export enum NotesFontSize {
  SMALL = 'Small',
  MEDIUM = 'Medium',
  LARGE = 'Large'
}

export const NotesFontSizes = [
  { value: NotesFontSize.SMALL, fontSizePx: '14px' },
  { value: NotesFontSize.MEDIUM, fontSizePx: '16px' },
  { value: NotesFontSize.LARGE, fontSizePx: '18px' }
];


export enum OrderBy {
  ALPHA = 'alpha',
  DATE = 'date'
}
